exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h3.h3[data-v-4570d4cc]{color:#fff}.block-blue[data-v-4570d4cc]{background-color:#003a70;color:#fff}", "", {"version":3,"sources":["/./client/components/pages/understandingYourReport/BlueCallToAction.vue"],"names":[],"mappings":"AACA,uBACE,UAAe,CAChB,AACD,6BACE,yBAA0B,AAC1B,UAAe,CAChB","file":"BlueCallToAction.vue","sourcesContent":["\nh3.h3[data-v-4570d4cc] {\n  color: #FFFFFF;\n}\n.block-blue[data-v-4570d4cc] {\n  background-color: #003A70;\n  color: #FFFFFF;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap&-autoprefixer!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-4570d4cc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/components/pages/understandingYourReport/BlueCallToAction.vue
// module id = 307
// module chunks = 0